import { useCallback } from 'react';

import { useSelector } from 'react-redux';

import { selectAppSessionId } from 'store/session/selectors';

import { AppStartUavParams, UavEvents } from './types';
import useGetBaseUavParams from './useGetBaseUavParams';

export default function useGetAppEndUavParams() {
    const appSessionId = useSelector(selectAppSessionId);

    const getBaseUavParams = useGetBaseUavParams();

    const getAppEndUavParams = useCallback(():
        | AppStartUavParams
        | undefined => {
        const baseUavParams = getBaseUavParams(UavEvents.APP_END);

        if (baseUavParams && appSessionId) {
            return {
                ...baseUavParams,
                metadata: {
                    appSessionId,
                    activityDateTime: baseUavParams.timestamp,
                    ...baseUavParams.metadata,
                },
            };
        }

        return undefined;
    }, [getBaseUavParams, appSessionId]);

    return {
        getAppEndUavParams,
    };
}
